import { render, staticRenderFns } from "./SecureImage.vue?vue&type=template&id=4072a875"
import script from "./SecureImage.vue?vue&type=script&lang=js"
export * from "./SecureImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4072a875')) {
      api.createRecord('4072a875', component.options)
    } else {
      api.reload('4072a875', component.options)
    }
    module.hot.accept("./SecureImage.vue?vue&type=template&id=4072a875", function () {
      api.rerender('4072a875', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/SecureImage.vue"
export default component.exports